exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".info-panel {\n  position: absolute;\n  height: 100%;\n  width: 1000px;\n  top: 0;\n  right: 0;\n  z-index: 1000;\n  padding-left: 40px;\n  background-color: beige;\n  overflow: auto;\n  transition: all 0.4s ease-in-out;\n  transform: translateX(calc(100% - 40px));\n}\n.info-panel.info-active {\n  transform: translateX(0);\n}\n.angle.double.left.icon {\n  cursor: pointer;\n  position: absolute;\n  top: 50%;\n  left: 0;\n}\n.metadata-container {\n  position: absolute;\n  padding-left: 10px;\n  left: 50px;\n  top: 0;\n  height: 100%;\n  width: calc(100% - 50px);\n  overflow-y: auto;\n  overflow-x: hidden;\n}\n", ""]);

// exports
